
import React, { ReactNode } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useAuth } from '@/context/SupabaseAuthContext';

interface UserLayoutProps {
  children: ReactNode;
}

const UserLayout: React.FC<UserLayoutProps> = ({ children }) => {
  const { user, signOut } = useAuth();
  
  const handleLogout = () => {
    signOut();
  };
  
  return (
    <div className="flex flex-col min-h-screen">
      <Header 
        isLoggedIn={!!user} 
        userRole="user"
        onLogout={handleLogout}
      />
      
      <main className="flex-grow bg-gray-50">
        {children}
      </main>
      
      <Footer />
    </div>
  );
};

export default UserLayout;
